module.exports = __webpack_public_path__ + "img/logo-light_m3.bd9f17c6.png";